module.exports = __webpack_public_path__ + "static/media/selfportraite.0c445765.jpeg";